import { User } from '../user';

export interface DataMarker {
  companyId?: string;
  user?: User;
  topic?: string;
  view: string;
  entityId: string;
  field?: string;
  value?: string;
  type: DataMarkerType;
}

export enum DataMarkerType {
  Stop = 0,
  View,
  Edit,
}
